"use client";

import { PromptHistoryDialog } from "@shared/components/PromptHistoryDialog";
import { Tabs, TabsContent } from "@ui/components/tabs";
import { useLocale, useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { useImageToPrompt } from "../hooks/use-image-to-prompt";
import { ImagePromptConverter } from "./ImagePromptConverter";
import { ImagePromptFaqSection } from "./ImagePromptFaqSection";
import { ProcessSteps } from "./ProcessSteps";
import ImageComparisonShowcase from "./image-comparison-showcase";

export function ImageToPromptClient() {
	const [selectedTab, setSelectedTab] = useState<"image" | "text">("image");
	const [isHistoryOpen, setIsHistoryOpen] = useState(false);
	const { promptHistory, setPromptHistory } = useImageToPrompt();
	const locale = useLocale();
	const t = useTranslations("imageToPrompt.components");

	// 监听打开历史记录对话框的事件
	useEffect(() => {
		const handleOpenHistory = () => {
			setIsHistoryOpen(true);
		};

		window.addEventListener("openPromptHistory", handleOpenHistory);

		return () => {
			window.removeEventListener("openPromptHistory", handleOpenHistory);
		};
	}, []);

	// 监听触发图片上传的事件
	useEffect(() => {
		const handleTriggerUpload = () => {
			// Find and click the hidden file input
			const fileInput = document.querySelector(
				'input[type="file"]',
			) as HTMLInputElement;
			if (fileInput) {
				fileInput.click();
			}
		};

		window.addEventListener("triggerImageUpload", handleTriggerUpload);

		return () => {
			window.removeEventListener(
				"triggerImageUpload",
				handleTriggerUpload,
			);
		};
	}, []);

	return (
		<div className="space-y-6">
			<Tabs
				defaultValue="image"
				value={selectedTab}
				onValueChange={(value) =>
					setSelectedTab(value as "image" | "text")
				}
			>
				<TabsContent value="image" className="mt-6">
					<ImagePromptConverter />
				</TabsContent>

				<TabsContent value="text" className="mt-6">
					<div className="p-6 border rounded-xl">
						<div className="flex items-center justify-center h-64">
							<p className="text-muted-foreground">
								{t("textToPrompt.feature")}
							</p>
						</div>
					</div>
				</TabsContent>
			</Tabs>

			<ProcessSteps key={`process-steps-${locale}`} />

			<PromptHistoryDialog
				open={isHistoryOpen}
				onOpenChange={setIsHistoryOpen}
			/>

			<div className="mt-16">
				<ImageComparisonShowcase />
			</div>

			<div className="mt-16 mb-12">
				<ImagePromptFaqSection />
			</div>
		</div>
	);
}
